import { render, staticRenderFns } from "./MarginTax.vue?vue&type=template&id=e57320e8&"
import script from "./MarginTax.vue?vue&type=script&lang=js&"
export * from "./MarginTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports